export default "__VITE_ASSET__D_$5GIoo__"